import { ResourceNameTypeEnum } from '@bondsports/types';

export interface ResourceSettingsDto {
	id?: number;
	organizationId: number;
	key: string;
	entityType: ResourceNameTypeEnum;
	entityId?: number;
	value: string;
}

export enum ESessionResourceSettingKey {
	HIDE_EVENT_TIMES = 'isHideEventTimes',
	HIDE_SEASON_SCHEDULE = 'isHideSeasonSchedule',
	DISPLAY_REMAINING_SPOTS = 'isDisplayRemainingSpots',
}
